/**
 * @version: 1.0.0
 * @author: John Bandy, john@concatsys.com
 * @company: Concat Systems, Inc.
 *
 * @description: a robust logging library, beyond the standard console.log.
 *
 * @copyright 2020 Concat Systems, Inc.
 *
 * {@link https://github.com/ConcatSystems/ConcatJS}
 */


// imports
import Cookies from "js-cookie";
import { Pad } from "../../utils/Numbers.js";
import { Timecode } from "../../utils/Dates.js";
import { Levels } from "./Levels.js";


//------------------------------------------------------------------------------
// consts
const LOG_LEVEL_COOKIE = "csi-log-level";

// vars
let options = {
  useCounter : true,
  useTimecode : true
};
let _level = Cookies.get( LOG_LEVEL_COOKIE ) || Levels.ERROR;
let _counter = 0;



//------------------------------------------------------------------------------
const _log = ( () => 
  {
    let log = console.log;

    return function( id, ...args ) {

      args.unshift( `${id}` );

      if( options.useTimecode )
        args.unshift( `[${Timecode( new Date() )}]` );
      
      log.apply( console, args );
    };
  })()


// the actual logging function  
//------------------------------------------------------------------------------
const _Out = function( level, ...args ) 
  {      
    _normalize( level ) <= _level
      && _log.apply( this, args );
  }

// helper/convenience funcs
//------------------------------------------------------------------------------
const _Level = function() 
  {
    // getter
    if( arguments.length === 0 )
      return( _level );

    // setter (with cookie)
    _level = _normalize( arguments[0] );
    Cookies.set( LOG_LEVEL_COOKIE, _level );
  }
//------------------------------------------------------------------------------
const _normalize = ( lvl ) => 
  {
    let v = ( typeof lvl === "string" )
          ? Levels[ lvl.toUpperCase() ]
          : ( typeof lvl === "number" ) && Levels.NONE < lvl && lvl <= Levels.DEBUG
          ? lvl
          : undefined;
    return( v || Levels.NONE );
  }

// public access
//------------------------------------------------------------------------------
let Log = {

  // level consts
  Levels : Levels,

  // get/set level
  level  : _Level,

  // two different methods to the output function
  _      : _Out,
  out    : _Out,

  // shortcut methods
  error  : function() { _Out.apply( this, [ Levels.ERROR ].concat( Array.prototype.slice.call( arguments ) ) ); },
  warn   : function() { _Out.apply( this, [ Levels.WARN  ].concat( Array.prototype.slice.call( arguments ) ) ); },
  info   : function() { _Out.apply( this, [ Levels.INFO  ].concat( Array.prototype.slice.call( arguments ) ) ); },
  debug  : function() { _Out.apply( this, [ Levels.DEBUG ].concat( Array.prototype.slice.call( arguments ) ) ); }
}


if( window )
{
  window.concat = window.concat || {};
  window.concat.Log = window.concat.Log || Log;
}

// end module
export { Log };
